// extracted by mini-css-extract-plugin
export var cartDrawer = "CartDrawer-module--cartDrawer--1RUlH";
export var cartDrawerHeader = "CartDrawer-module--cartDrawerHeader--3kGPS";
export var cartCloseButton = "CartDrawer-module--cartCloseButton--3Wjbc";
export var productSection = "CartDrawer-module--productSection--1WyM5";
export var priceSection = "CartDrawer-module--priceSection--2YDXF";
export var buttonSection = "CartDrawer-module--buttonSection--1dGNV";
export var disclaimer = "CartDrawer-module--disclaimer--3caH2";
export var checkbox = "CartDrawer-module--checkbox--UhHVs";
export var checkboxSubstitute = "CartDrawer-module--checkboxSubstitute--gexpi";
export var checked = "CartDrawer-module--checked--1Z7lC";
export var checkboxLabel = "CartDrawer-module--checkboxLabel--3GExH";